import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Create axios instance with credentials
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Error formatter for API responses
export const formatApiErrorDetail = (detail) => {
  if (detail == null) return 'Algo salió mal. Por favor intenta de nuevo.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};

// Auth API
export const authAPI = {
  login: async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    return data;
  },

  register: async (email, password, name) => {
    const { data } = await api.post('/auth/register', { email, password, name });
    return data;
  },

  logout: async () => {
    const { data } = await api.post('/auth/logout');
    return data;
  },

  getMe: async () => {
    const { data } = await api.get('/auth/me');
    return data;
  },

  refresh: async () => {
    const { data } = await api.post('/auth/refresh');
    return data;
  }
};

// Articles API
export const articlesAPI = {
  getAll: async (params = {}) => {
    const { data } = await api.get('/articles', { params });
    return data;
  },

  getBySlug: async (slug) => {
    const { data } = await api.get(`/articles/${slug}`);
    return data;
  },

  search: async (query) => {
    const { data } = await api.get('/articles/search', { params: { q: query } });
    return data;
  },

  create: async (articleData) => {
    const { data } = await api.post('/articles', articleData);
    return data;
  },

  update: async (id, articleData) => {
    const { data } = await api.put(`/articles/${id}`, articleData);
    return data;
  },

  delete: async (id) => {
    const { data } = await api.delete(`/articles/${id}`);
    return data;
  }
};

// Categories API
export const categoriesAPI = {
  getAll: async () => {
    const { data } = await api.get('/categories');
    return data;
  }
};

export default api;
